// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Body Styles */
body {
  font-family: 'Arial', sans-serif;
  background-color: #f4faff;  /* Light blue background */
  color: #333;
  margin: 0;
  padding: 20px;
}

/* App Container */
div {
  display: flex;
  flex-direction: column;
  align-items: left;
}

/* Forms and Panels */
form, .panel {
  background-color: #ffffff; /* White background for forms and panels */
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 10px;
  width: 90%;
  max-width: 190px;
}

/* Headings */
h1, h2, h3 {
  color: #005792; /* Dark blue for headings */
}

/* Input and Buttons */
input[type="text"], input[type="number"], button {
  border: 2px solid #005792;
  border-radius: 5px;
  padding: 10px;
  margin-top: 5px;
  width: 100%;
  box-sizing: border-box;
}

button {
  background-color: #007acc; /* Bright blue for buttons */
  color: white;
  cursor: pointer;
}

button:hover {
  background-color: #005792; /* Darker blue on hover */
}

.NeoTool-header {
  background-color: #2c3e50; /* Dark blue background */
  color: #ecf0f1; /* Light grey text */
  font-family: 'Arial', sans-serif; /* Modern Font */
  padding: 5px 20px; /* Further reduced top/bottom padding, keep horizontal padding */
  text-align: center; /* Centering the text */
  border-bottom: 3px solid #3498db; /* Blue bottom border */
  width: 100%; /* Full width */
  box-sizing: border-box; /* Includes padding in width calculation */
  position: fixed; /* Fixed at the top */
  top: 0; /* Align top */
  left: 0; /* Align left */
  right: 0; /* Align right */
  display: flex; /* Enables flexbox */
  justify-content: center; /* Centers content horizontally */
  align-items: center; /* Aligns content vertically */
  flex-wrap: wrap; /* Allows wrapping */
  z-index: 1000; /* Ensure it's on top of other content */
}

.NeoTool-header p {
  margin: 0; /* Remove vertical margin */
  padding: 0; /* Remove padding */
  font-size: 14px; /* Reduced font size */
}

.NeoTool-header a {
  color: #3498db; /* Blue links */
  text-decoration: none; /* No underline */
  font-size: 14px; /* Consistent font size with other text */
}

.NeoTool-header a:hover {
  text-decoration: underline; /* Underline on hover */
}

@media (max-width: 600px) {
  .NeoTool-header {
      flex-direction: column; /* Stacks content vertically on small screens */
      padding: 5px 10px; /* Even more reduced padding in mobile view */
  }
}

/* Custom Components Styling */
.SwitchDisplay {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e6f7ff; /* Very light blue for switch display */
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  width: auto; /* adjust this as needed */
  max-width: 200px; /* maximum width for each switch */
}

.ExpandablePanel {
  transition: all 0.3s ease;
}

.ExpandablePanel.expanded {
  max-height: 500px;
  overflow: hidden;
}

/* Specific Panel Styling */
.TrophicFeedsPanel, .MalnutritionCalc, .InHospitalRegimen, .DischargeRegimen {
  background-color: #e6f7ff; /* Consistency in panel colors */
}

/* Link Styles */
a {
  color: #007acc;
}

a:hover {
  color: #005792;
}

/* App container */
.app-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align children to the left */
  padding: 20px; /* Add padding for some space around the content */
  width: 100%; /* Ensure it takes full width of the viewport */
}

.switches-container {
  display: grid;
  grid-auto-columns: minmax(120px, 1fr); /* Dynamic column width based on content, with a minimum and flexible maximum */
  gap: 10px; /* Space between the components */
  padding: 20px; /* Padding around the grid */
  overflow-x: auto; /* Allows horizontal scrolling if more items than can fit */
}

.parameters-and-switches {
  display: grid;
  grid-template-columns: 1fr 5fr; /* Adjust this if more columns are needed */
  grid-gap: 50px; /* Space between items */
}

.first-header{
  display: grid;
  grid-template-columns: 1fr 3fr; /* Adjust this if more columns are needed */
  grid-gap: 50px; /* Space between items */
  align-items: center;
}

@media (max-width: 1001px) { /* Adjust this breakpoint to your needs */
  .parameters-and-switches {
    grid-template-columns: 1fr; /* All items will stack in one column on small screens */
  }
  .first-header {
    grid-template-columns: 1fr; /* All items will stack in one column on small screens */
  }
}

.first-header img {
  display: block; /* Ensures the image does not have inline behavior */
  max-width: 100%; /* Makes sure the image is responsive and does not overflow its container */
  height: auto; /* Keeps the image's aspect ratio intact */
  border: 1px solid #ccc; /* Adds a light grey border around the image */
  padding: 10px; /* Adds padding around the image */
  border-radius: 8px; /* Rounds the corners of the image */
  box-shadow: 0 2px 4px rgba(0,0,0,0.15); /* Adds a subtle shadow for depth */
  margin-bottom: 20px; /* Adds space between the image and the text below it */
}



/* For screens wider than 600px */
@media (min-width: 1001px) {
  .switches-container {
    grid-auto-flow: column; /* Directs items to flow into new columns rather than new rows */
    grid-template-rows: repeat(2, 1fr); /* Ensures exactly two rows */
  }

}

/* For screens 600px wide or less */
@media (max-width: 1000px) {
  .switches-container {
    grid-auto-flow: row; /* Directs items to flow into new rows rather than new columns */
    grid-template-columns: repeat(2, 1fr); /* Ensures exactly two columns */
  }

}

.disclaimer {
  background-color: #f9f9f9; /* Light grey background */
  border: 1px solid #ccc; /* Grey border */
  padding: 15px; /* Padding around the text */
  margin-top: 20px; /* Margin on the top to separate from elements above */
  font-size: 14px; /* Suitable font size */
  line-height: 1.6; /* Line height for better readability */
  border-radius: 8px; /* Rounded corners */
  box-shadow: 0 4px 6px rgba(0,0,0,0.1); /* Subtle shadow for 3D effect */
}

.disclaimer h1, .disclaimer h2, .disclaimer p {
  margin-top: 0; /* Removes the top margin */
  margin-bottom: 10px; /* Reduces the bottom margin */
}

.disclaimer h1 {
  margin-bottom: 5px; /* Even smaller bottom margin for h1 */
}

.disclaimer h2 {
  margin-bottom: 5px; /* Even smaller bottom margin for h2 */
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,yBAAyB,GAAG,0BAA0B;EACtD,WAAW;EACX,SAAS;EACT,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB,EAAE,0CAA0C;EACrE,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,cAAc,EAAE,2BAA2B;AAC7C;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,cAAc,EAAE,oBAAoB;EACpC,gCAAgC,EAAE,gBAAgB;EAClD,iBAAiB,EAAE,gEAAgE;EACnF,kBAAkB,EAAE,uBAAuB;EAC3C,gCAAgC,EAAE,uBAAuB;EACzD,WAAW,EAAE,eAAe;EAC5B,sBAAsB,EAAE,0CAA0C;EAClE,eAAe,EAAE,qBAAqB;EACtC,MAAM,EAAE,cAAc;EACtB,OAAO,EAAE,eAAe;EACxB,QAAQ,EAAE,gBAAgB;EAC1B,aAAa,EAAE,oBAAoB;EACnC,uBAAuB,EAAE,iCAAiC;EAC1D,mBAAmB,EAAE,8BAA8B;EACnD,eAAe,EAAE,oBAAoB;EACrC,aAAa,EAAE,wCAAwC;AACzD;;AAEA;EACE,SAAS,EAAE,2BAA2B;EACtC,UAAU,EAAE,mBAAmB;EAC/B,eAAe,EAAE,sBAAsB;AACzC;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,qBAAqB,EAAE,iBAAiB;EACxC,eAAe,EAAE,yCAAyC;AAC5D;;AAEA;EACE,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA;EACE;MACI,sBAAsB,EAAE,+CAA+C;MACvE,iBAAiB,EAAE,6CAA6C;EACpE;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB,EAAE,uCAAuC;EAClE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW,EAAE,0BAA0B;EACvC,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,+BAA+B;EACxD,aAAa,EAAE,kDAAkD;EACjE,WAAW,EAAE,+CAA+C;AAC9D;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,+EAA+E;EACtH,SAAS,EAAE,iCAAiC;EAC5C,aAAa,EAAE,4BAA4B;EAC3C,gBAAgB,EAAE,2DAA2D;AAC/E;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,2CAA2C;EAC3E,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,2CAA2C;EAC3E,cAAc,EAAE,wBAAwB;EACxC,mBAAmB;AACrB;;AAEA,6BAA6B,yCAAyC;EACpE;IACE,0BAA0B,EAAE,wDAAwD;EACtF;EACA;IACE,0BAA0B,EAAE,wDAAwD;EACtF;AACF;;AAEA;EACE,cAAc,EAAE,oDAAoD;EACpE,eAAe,EAAE,2EAA2E;EAC5F,YAAY,EAAE,0CAA0C;EACxD,sBAAsB,EAAE,8CAA8C;EACtE,aAAa,EAAE,kCAAkC;EACjD,kBAAkB,EAAE,oCAAoC;EACxD,sCAAsC,EAAE,mCAAmC;EAC3E,mBAAmB,EAAE,uDAAuD;AAC9E;;;;AAIA,iCAAiC;AACjC;EACE;IACE,sBAAsB,EAAE,gEAAgE;IACxF,kCAAkC,EAAE,6BAA6B;EACnE;;AAEF;;AAEA,mCAAmC;AACnC;EACE;IACE,mBAAmB,EAAE,gEAAgE;IACrF,qCAAqC,EAAE,gCAAgC;EACzE;;AAEF;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,sBAAsB,EAAE,gBAAgB;EACxC,aAAa,EAAE,4BAA4B;EAC3C,gBAAgB,EAAE,sDAAsD;EACxE,eAAe,EAAE,uBAAuB;EACxC,gBAAgB,EAAE,uCAAuC;EACzD,kBAAkB,EAAE,oBAAoB;EACxC,qCAAqC,EAAE,gCAAgC;AACzE;;AAEA;EACE,aAAa,EAAE,2BAA2B;EAC1C,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,kBAAkB,EAAE,sCAAsC;AAC5D","sourcesContent":["/* General Body Styles */\nbody {\n  font-family: 'Arial', sans-serif;\n  background-color: #f4faff;  /* Light blue background */\n  color: #333;\n  margin: 0;\n  padding: 20px;\n}\n\n/* App Container */\ndiv {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n}\n\n/* Forms and Panels */\nform, .panel {\n  background-color: #ffffff; /* White background for forms and panels */\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  margin: 10px;\n  width: 90%;\n  max-width: 190px;\n}\n\n/* Headings */\nh1, h2, h3 {\n  color: #005792; /* Dark blue for headings */\n}\n\n/* Input and Buttons */\ninput[type=\"text\"], input[type=\"number\"], button {\n  border: 2px solid #005792;\n  border-radius: 5px;\n  padding: 10px;\n  margin-top: 5px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\nbutton {\n  background-color: #007acc; /* Bright blue for buttons */\n  color: white;\n  cursor: pointer;\n}\n\nbutton:hover {\n  background-color: #005792; /* Darker blue on hover */\n}\n\n.NeoTool-header {\n  background-color: #2c3e50; /* Dark blue background */\n  color: #ecf0f1; /* Light grey text */\n  font-family: 'Arial', sans-serif; /* Modern Font */\n  padding: 5px 20px; /* Further reduced top/bottom padding, keep horizontal padding */\n  text-align: center; /* Centering the text */\n  border-bottom: 3px solid #3498db; /* Blue bottom border */\n  width: 100%; /* Full width */\n  box-sizing: border-box; /* Includes padding in width calculation */\n  position: fixed; /* Fixed at the top */\n  top: 0; /* Align top */\n  left: 0; /* Align left */\n  right: 0; /* Align right */\n  display: flex; /* Enables flexbox */\n  justify-content: center; /* Centers content horizontally */\n  align-items: center; /* Aligns content vertically */\n  flex-wrap: wrap; /* Allows wrapping */\n  z-index: 1000; /* Ensure it's on top of other content */\n}\n\n.NeoTool-header p {\n  margin: 0; /* Remove vertical margin */\n  padding: 0; /* Remove padding */\n  font-size: 14px; /* Reduced font size */\n}\n\n.NeoTool-header a {\n  color: #3498db; /* Blue links */\n  text-decoration: none; /* No underline */\n  font-size: 14px; /* Consistent font size with other text */\n}\n\n.NeoTool-header a:hover {\n  text-decoration: underline; /* Underline on hover */\n}\n\n@media (max-width: 600px) {\n  .NeoTool-header {\n      flex-direction: column; /* Stacks content vertically on small screens */\n      padding: 5px 10px; /* Even more reduced padding in mobile view */\n  }\n}\n\n/* Custom Components Styling */\n.SwitchDisplay {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #e6f7ff; /* Very light blue for switch display */\n  padding: 10px;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  width: auto; /* adjust this as needed */\n  max-width: 200px; /* maximum width for each switch */\n}\n\n.ExpandablePanel {\n  transition: all 0.3s ease;\n}\n\n.ExpandablePanel.expanded {\n  max-height: 500px;\n  overflow: hidden;\n}\n\n/* Specific Panel Styling */\n.TrophicFeedsPanel, .MalnutritionCalc, .InHospitalRegimen, .DischargeRegimen {\n  background-color: #e6f7ff; /* Consistency in panel colors */\n}\n\n/* Link Styles */\na {\n  color: #007acc;\n}\n\na:hover {\n  color: #005792;\n}\n\n/* App container */\n.app-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* Align children to the left */\n  padding: 20px; /* Add padding for some space around the content */\n  width: 100%; /* Ensure it takes full width of the viewport */\n}\n\n.switches-container {\n  display: grid;\n  grid-auto-columns: minmax(120px, 1fr); /* Dynamic column width based on content, with a minimum and flexible maximum */\n  gap: 10px; /* Space between the components */\n  padding: 20px; /* Padding around the grid */\n  overflow-x: auto; /* Allows horizontal scrolling if more items than can fit */\n}\n\n.parameters-and-switches {\n  display: grid;\n  grid-template-columns: 1fr 5fr; /* Adjust this if more columns are needed */\n  grid-gap: 50px; /* Space between items */\n}\n\n.first-header{\n  display: grid;\n  grid-template-columns: 1fr 3fr; /* Adjust this if more columns are needed */\n  grid-gap: 50px; /* Space between items */\n  align-items: center;\n}\n\n@media (max-width: 1001px) { /* Adjust this breakpoint to your needs */\n  .parameters-and-switches {\n    grid-template-columns: 1fr; /* All items will stack in one column on small screens */\n  }\n  .first-header {\n    grid-template-columns: 1fr; /* All items will stack in one column on small screens */\n  }\n}\n\n.first-header img {\n  display: block; /* Ensures the image does not have inline behavior */\n  max-width: 100%; /* Makes sure the image is responsive and does not overflow its container */\n  height: auto; /* Keeps the image's aspect ratio intact */\n  border: 1px solid #ccc; /* Adds a light grey border around the image */\n  padding: 10px; /* Adds padding around the image */\n  border-radius: 8px; /* Rounds the corners of the image */\n  box-shadow: 0 2px 4px rgba(0,0,0,0.15); /* Adds a subtle shadow for depth */\n  margin-bottom: 20px; /* Adds space between the image and the text below it */\n}\n\n\n\n/* For screens wider than 600px */\n@media (min-width: 1001px) {\n  .switches-container {\n    grid-auto-flow: column; /* Directs items to flow into new columns rather than new rows */\n    grid-template-rows: repeat(2, 1fr); /* Ensures exactly two rows */\n  }\n\n}\n\n/* For screens 600px wide or less */\n@media (max-width: 1000px) {\n  .switches-container {\n    grid-auto-flow: row; /* Directs items to flow into new rows rather than new columns */\n    grid-template-columns: repeat(2, 1fr); /* Ensures exactly two columns */\n  }\n\n}\n\n.disclaimer {\n  background-color: #f9f9f9; /* Light grey background */\n  border: 1px solid #ccc; /* Grey border */\n  padding: 15px; /* Padding around the text */\n  margin-top: 20px; /* Margin on the top to separate from elements above */\n  font-size: 14px; /* Suitable font size */\n  line-height: 1.6; /* Line height for better readability */\n  border-radius: 8px; /* Rounded corners */\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1); /* Subtle shadow for 3D effect */\n}\n\n.disclaimer h1, .disclaimer h2, .disclaimer p {\n  margin-top: 0; /* Removes the top margin */\n  margin-bottom: 10px; /* Reduces the bottom margin */\n}\n\n.disclaimer h1 {\n  margin-bottom: 5px; /* Even smaller bottom margin for h1 */\n}\n\n.disclaimer h2 {\n  margin-bottom: 5px; /* Even smaller bottom margin for h2 */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
